import React from "react";
import "./styles/WebsiteFooter.css";
import logo from '../assets/logo.png';

const WebsiteFooter = () => {

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section footer-logo">
          <h4>The Konkan Route</h4>
          <img src={logo} alt="Konkan Route Logo" />
        </div>

        <div className="footer-section">
          <h4>Pages</h4>
          <a href="http://konkanroute.com/">Home</a>
          <a href="http://konkanroute.com/Product">Products</a>
          <a href="http://konkanroute.com/Collections/Destination">Destinations</a>
          <a href="http://konkanroute.com/Collections/Category/Munchies">Categories</a>
          <a href="http://konkanroute.com/Collections">Shop</a>
        </div>

        <div className="footer-section">
          <h4>About Us</h4>
          <a href="http://konkanroute.com/Product">Products</a>
          <a href="http://konkanroute.com/#aboutus">About Us</a>
          <a href="http://konkanroute.com/ContactUs">Contact Us</a>
          <a href="tel:+91123456789">Call Us</a>
          {/* <a href="mailto:care@konkanroute.com">Email Us</a> */}
          <a href="https://mail.google.com/mail/u/0/?fs=1&to=care@konkanroute.com&su=Your+Subject&body=Your+Message&tf=cm" target="_blank" rel="noopener noreferrer">Email Us</a>
        </div>

        <div className="footer-section">
          <h4>Policy</h4>
          <a href="https://merchant.razorpay.com/policy/OvNLX8TJVWmfht/privacy">Privacy Policy</a>
          <a href="https://merchant.razorpay.com/policy/OvNLX8TJVWmfht/terms">Terms and Conditions</a>
          <a href="https://merchant.razorpay.com/policy/OvNLX8TJVWmfht/contact_us">Contact Us</a>
          <a href="https://merchant.razorpay.com/policy/OvNLX8TJVWmfht/shipping">Shipping and Delivery Policy</a>
          <a href="https://merchant.razorpay.com/policy/OvNLX8TJVWmfht/refund">Cancellation and Refund Policy</a>
          <div className="policy-note">Fssai Lic. No.: 10018043002239</div>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
